import { useEffect, useState } from 'react'
import { Input, Toggle } from '@/components/ui'
import { useContactContext } from '../ContactShow'

// Composant pour les informations GLI
const GLIInformation = () => {
  const { contact, wasUpdated, isPendingAction} = useContactContext()
  const [animateUpdate, setAnimateUpdate] = useState(false)
  
  useEffect(() => {
    if (wasUpdated) {
      setAnimateUpdate(true)
      const timer = setTimeout(() => {
        setAnimateUpdate(false)
      }, 2000) // Durée de l'animation
      
      return () => clearTimeout(timer)
    }
  }, [wasUpdated, isPendingAction])
  
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-2">Informations GLI</h2>
      <div className={`bg-gray-100 p-6 rounded-lg transition-all duration-1000 ${animateUpdate ? 'skeleton' : ''}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Toggle.Display label="Locataire sous GLI" value={contact.gli || false}/>
            <Input.Display label="N° de CAF" value={contact.numero_caf}/>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Information garant :</label>
            <p className="textarea textarea-bordered w-full">
              {contact.garants || ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default GLIInformation